const normalizeImageUrl = (value) => {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
};

export const getProductInitials = (name) => {
    if (!name || typeof name !== 'string') {
        return '?';
    }

    const words = name.trim().split(/\s+/).filter(Boolean);

    if (words.length >= 2) {
        return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
    }

    const compact = name.trim().replace(/\s+/g, '');
    return (compact.slice(0, 2) || '?').toUpperCase();
};

export const getValidImageUrls = (sources) => {
    if (!sources) {
        return [];
    }

    const list = Array.isArray(sources) ? sources : [sources];
    return list.map(normalizeImageUrl).filter(Boolean);
};

export const getProductImageUrl = (product) => {
    if (!product) {
        return null;
    }

    const candidates = [];

    if (Array.isArray(product.imageUrl)) {
        candidates.push(...product.imageUrl);
    } else if (product.imageUrl) {
        candidates.push(product.imageUrl);
    }

    if (Array.isArray(product.variants)) {
        product.variants.forEach((variant) => {
            if (Array.isArray(variant?.images)) {
                candidates.push(...variant.images);
            }
            if (variant?.imageUrl) {
                candidates.push(variant.imageUrl);
            }
        });
    }

    for (const candidate of candidates) {
        const url = normalizeImageUrl(candidate);
        if (url) {
            return url;
        }
    }

    return null;
};
